import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileCartSidebarComponent } from './mobile-cart-sidebar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';
import { CartDetailsModule } from './components/cart-details/cart-details.module';


@NgModule({
  declarations: [MobileCartSidebarComponent],
  exports: [
    MobileCartSidebarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule,
    CartDetailsModule
  ]
})
export class MobileCartSidebarModule {
}
